import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
var borderRadiusStyles = function borderRadiusStyles(edges, theme) {
  if (edges === 'rounded') {
    return 99;
  }
  if (edges === 'sharp') {
    return 0;
  }
  return theme.shape.borderRadius;
};
export var StyledTextField = styled(TextField)(function (_ref) {
  var edges = _ref.edges,
    variant = _ref.variant,
    required = _ref.required,
    error = _ref.error,
    value = _ref.value,
    theme = _ref.theme;
  return {
    margin: 0,
    '& input[type=number]::-webkit-inner-spin-button, * input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none'
    },
    '& input[type="date"]::-webkit-inner-spin-button, & input[type="date"]::-webkit-calendar-picker-indicator': {
      background: 'none',
      display: 'none',
      '-webkit-appearance': 'none'
    },
    '& input.MuiInputBase-inputAdornedEnd[type=time]::-webkit-calendar-picker-indicator': {
      position: 'absolute',
      right: 0,
      padding: 8,
      opacity: 0,
      zIndex: 2,
      cursor: 'pointer',
      display: 'block'
    },
    '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
      marginTop: 0
    },
    '& .MuiInputBase-root': {
      border: variant === 'filled' ? "2px solid " + theme.palette.grey.transparent : null,
      borderRadius: borderRadiusStyles(edges, theme)
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.grey.transparent
    },
    '& .Mui-focused': {
      border: variant === 'filled' ? "2px solid " + (required ? theme.palette.secondary.main : null) : null
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: required && !value || error ? theme.palette.secondary.main : null
    },
    '& .MuiFilledInput-root.Mui-focused': {
      borderColor: required && !value || error ? theme.palette.secondary.main : 'transparent'
    },
    '& input': {
      '&::placeholder': {
        color: theme.palette.grey.main,
        opacity: 1
      },
      padding: theme.spacing(3, 4)
    }
  };
});